import { Component, OnInit, Input } from '@angular/core';
import { Module } from 'src/app/interfaces/module.interface';
import { ApiGeolocationService } from 'src/app/services/api-geolocation.service';

@Component({
    selector: 'app-content-module',
    templateUrl: './content-module.component.html',
    styleUrls: ['./content-module.component.scss']
})
export class ContentModuleComponent implements OnInit {
    @Input() module: any;
    @Input() subtitle: string;
    activeCredits: boolean = false;
    getCountry: boolean = false;
    screenHeight: number;
    screenWidth: number;
    animateItem: boolean = false;

    constructor(private geolocationService: ApiGeolocationService) {
        this.onResize(event);
    }

    ngOnInit() {
    }

    onResize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }

    creditsAcitve() {
        this.activeCredits = !this.activeCredits;
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.animateItem = true;
        }
    }

    getGeolocation() {
        this.geolocationService.getGeolocation().subscribe(resp => {
            const data = resp[0];
            if (data.country_name == 'Republic of Kosovo' || data.country_name == 'Serbia' || data.country_name == 'Albania' || data.country_name == 'Montenegro' || data.country_name == 'Macedonia') {
                this.getCountry = false;
            } else {
                this.getCountry = true;
            }
        })
    }
}
